var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsOptional, IsString, MaxLength } from 'class-validator';
import { CancellationFeeWaiverReason } from '../enums/cancellation-fee-waiver-reason.enum.js';
/**
 * Erlassen (TM-9064): the practice explicitly forgives a pending
 * `CancellationFee`. `reason` is the structured enum used for reporting;
 * `freeText` is optional supplementary context.
 */
export class WaiveCancellationFeeDto {
    reason;
    freeText;
}
__decorate([
    IsEnum(CancellationFeeWaiverReason),
    __metadata("design:type", String)
], WaiveCancellationFeeDto.prototype, "reason", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(1000),
    __metadata("design:type", String)
], WaiveCancellationFeeDto.prototype, "freeText", void 0);
//# sourceMappingURL=waive-cancellation-fee.dto.js.map